// extracted by mini-css-extract-plugin
module.exports = {"card":"DownloadAppCard_card__sORZ6","text":"DownloadAppCard_text__AP2Zj","download-btn":"DownloadAppCard_download-btn__TW6gx","image":"DownloadAppCard_image__J0uet"};